import { StatusButton } from '@attive/ui/status-button'
import { Form } from 'react-router'
import { z } from 'zod'
import { GoogleIcon } from '#app/components/icons.tsx'
import { useIsPending } from './misc.tsx'

export const GITHUB_PROVIDER_NAME = 'github'
export const GOOGLE_PROVIDER_NAME = 'google'
// to add another provider, set their name here and add it to the providerNames below

export const providerNames = ['google'] as const
export type ProviderName = (typeof providerNames)[number]
export const ProviderNameSchema = z.enum(providerNames)

export const providerIcons: Record<ProviderName, React.ReactNode> = {
	// github: <Icon name="github-logo" />,
	google: <GoogleIcon />,
}

export const providerLabels: Record<ProviderName, string> = {
	// github: 'GitHub',
	google: 'Google',
}

export function ProviderConnectionForm({
	redirectTo,
	type,
	providerName,
}: {
	redirectTo?: string | null
	type: 'Connect' | 'Login' | 'Signup'
	providerName: ProviderName
}) {
	const label = providerLabels[providerName]
	const formAction = `/auth/${providerName}`
	const isPending = useIsPending({ formAction })
	return (
		<Form
			className="flex items-center justify-center gap-2"
			action={formAction}
			method="POST"
		>
			{redirectTo ? (
				<input type="hidden" name="redirectTo" value={redirectTo} />
			) : null}
			<StatusButton
				type="submit"
				className="w-full"
				status={isPending ? 'pending' : 'idle'}
			>
				<span className="inline-flex items-center gap-1.5">
					{providerIcons[providerName]}
					<span>
						{type} with {label}
					</span>
				</span>
			</StatusButton>
		</Form>
	)
}
